import * as z from 'zod';

import { numericStringFormSchema } from '@/_schemas/generic';
import { statusFormSchema } from '@/_schemas/status-input';

import { companyQuerySchema } from './company-query-schema';

export const companyFormSchema = companyQuerySchema
  .omit({
    short_name: true,
    status: true,
    zoom_meeting_code: true,
    brand_id: true,
    partner_id: true,
    audience_id: true,
    consumers: true,
    account_manager_id: true,
    relationship_score_id: true,
    organization_type_id: true,
    billing_system_id: true,
    billing_term_id: true,
    magazine_id: true,
    timezone_id: true,
    year_established: true,
    annual_meeting_month: true,
    contacts_count: true,
    tax_id: true,
    exempt: true,
  })
  .extend({
    name: z.string().min(3),
    short_name: z.string(),
    status: statusFormSchema,
    zoom_meeting_code: z.string(),
    year_established: z.object({ name: z.string(), value: z.string() }).nullable(),
    annual_meeting_month: z.object({ name: z.string(), value: z.string() }).nullable(),
    consumers: z.string().nullable(),
    tax_id: z.string(),
    exempt: z.string(),

    harvest: numericStringFormSchema(),
    box: numericStringFormSchema(),
    freshdesk: numericStringFormSchema(),
    client_assigned_vendor_id: z.string(),
    override_payable_name: z.string(),
  });

export type CompanyFormSchema = z.infer<typeof companyFormSchema>;
